import { cn } from "@/lib/utils";

export interface StatementPdfFrameProps {
  src: string;
  className?: string;
  title?: string;
}

export function StatementPdfFrame({ src, className, title }: StatementPdfFrameProps) {
  return (
    <iframe
      title={title ?? "Statement PDF"}
      src={src}
      className={cn("w-full h-[800px] border rounded-md bg-white", className)}
    />
  );
}
